const PaperTypeDto = {
	bekoszono_online_hu: 'bekoszono online hu',
	bekoszono_online_en: 'bekoszono online en',
	bekoszono_online_de: 'bekoszono online de',
	bekoszono_tukor_hu: 'bekoszono tukor hu',
	bekoszono_tukor_en: 'bekoszono tukor en',
	bekoszono_tukor_de: 'bekoszono tukor de',
	bekoszono_hu: 'bekoszono hu',
	bekoszono_en: 'bekoszono en',
	bekoszono_de: 'bekoszono de'
};

export default PaperTypeDto;
